import script from "./InAppNotificationsLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./InAppNotificationsLoader.vue?vue&type=script&setup=true&lang=js"

import "./InAppNotificationsLoader.vue?vue&type=style&index=0&id=6f248672&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f248672"]])

export default __exports__